import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Import } from 'assets/svg/icon-import.svg'

function IconImport(props: IconProps): JSX.Element {
  const title = 'icon-import'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Import {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconImport
